import { Context } from 'effect';
import { BuildRule, FinalisationRule, ModularTemplate, ModularTemplateListSummaries, Module, ModuleType, Ruleset, BUILD_RULES, FINALISATION_RULES, RULESETS, } from '../../schemas/modularTemplate';
export { BuildRule, FinalisationRule, ModularTemplate, ModularTemplateListSummaries, Module, ModuleType, Ruleset, BUILD_RULES, FINALISATION_RULES, RULESETS, };
export class ModularTemplateService extends Context.Tag('@fixtuur/backpack/ModularTemplateService')() {
}
